import { Reveal, SectionHeading } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Écoute & préparation",
    text: "Tout commence par un rendez-vous : vos envies, vos titres imposés, vos titres interdits. Ensemble, nous construisons le fil musical de votre journée, du vin d'honneur à la dernière danse.",
  },
  {
    num: "02",
    title: "Coordination & synergie",
    text: "Nous échangeons en amont avec vos témoins, vos prestataires et le lieu de réception. Chaque moment fort — ouverture de bal, discours, pièce montée — est synchronisé à la seconde près.",
  },
  {
    num: "03",
    title: "Performance live",
    text: "Le jour J, nous lisons la piste en direct : transitions adaptées, énergie maîtrisée, micro tendu au bon moment. Vous profitez de vos invités, nous nous occupons du reste.",
  },
];

export default function Manifesto() {
  return (
    <section id="methode" className="relative py-28 sm:py-36" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testId="manifesto-heading"
          eyebrow="La méthode KLMProd"
          title={
            <>
              Une soirée réussie <span className="text-gradient">ne s'improvise pas.</span>
            </>
          }
          text="Elle se prépare, en trois temps."
        />

        <div className="mt-16">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                className="group grid grid-cols-1 gap-4 border-t border-cyan-500/10 py-10 transition-colors duration-500 hover:bg-cyan-400/[0.03] md:grid-cols-12 md:items-baseline md:gap-8"
                data-testid={`manifesto-chapter-${c.num}`}
              >
                <span className="font-mono-brand text-sm text-cyan-400 md:col-span-2">/{c.num}</span>
                <h3 className="font-display text-2xl font-bold text-slate-100 transition-colors duration-500 group-hover:text-cyan-300 md:col-span-4">
                  {c.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-slate-400 md:col-span-6">{c.text}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-cyan-500/10" />
        </div>
      </div>
    </section>
  );
}
